import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Applies a CSS class to the document root element based on the current route.
 * This allows per-page styling (like background patterns) defined in CSS.
 */
export default function RouteClassApplier() {
  const location = useLocation();

  useEffect(() => {
    const root = document.documentElement;
    
    // List of classes we want to manage
    const pageClasses = [
      "page-home",
      "page-services",
      "page-portfolio",
      "page-pricing",
      "page-about",
      "page-contact",
      "page-auth",
      "page-dashboard",
      "page-admin"
    ];

    // Remove all existing page-specific classes
    root.classList.remove(...pageClasses);

    const path = location.pathname;

    if (path === "/" || path === "") {
      root.classList.add("page-home");
    } else if (path.startsWith("/services")) {
      root.classList.add("page-services");
    } else if (path.startsWith("/portfolio")) {
      root.classList.add("page-portfolio");
    } else if (path.startsWith("/pricing")) {
      root.classList.add("page-pricing");
    } else if (path.startsWith("/about")) {
      root.classList.add("page-about");
    } else if (path.startsWith("/contact")) {
      root.classList.add("page-contact");
    } else if (path.startsWith("/login") || path.startsWith("/register") || path.startsWith("/forgot-password") || path.startsWith("/reset-password")) {
      root.classList.add("page-auth");
    } else if (path.startsWith("/dashboard")) {
      root.classList.add("page-dashboard");
    } else if (path.startsWith("/admin")) {
      root.classList.add("page-admin");
    }
  }, [location.pathname]);

  return null;
}
